module.exports = __webpack_public_path__ + "img/free.51b65ce2.svg";